import {customTermFilter} from "../../../../vue/filters/CustomTerm";

function customTerm() {
    return customTermFilter;
}

export default customTerm;